import React, { useState } from "react";

const OrderContext = React.createContext({
  customer: null,
  customerInfoMode: null,
  order: null,
  orderInfoMode: null,

  setCustomerHandler: (customer) => {},
  setCustomerInfoModeHandler: (mode) => {},
  setOrderHandler: (order) => {},
  setOrderInfoModeHandler: (mode) => {},

  //   customerGUID: "",
  //   customerCompMode: 0,
  //   orderGUID: "",
  //   orderInfoCompMode: 0,

  //   setCustomerGUID: (customerGUID) => {},
  //   setCustomerCompMode: (mode) => {},
  //   setOrderGUID: (orderGUID) => {},
  //   setOrderInfoMode: (mode) => {},
});

export const OrderContextProvider = (props) => {
  const [customer, setCustomer] = useState(null);
  const [customerInfoMode, setCustomerInfoMode] = useState(null);
  const [order, setOrder] = useState(null);
  const [orderInfoMode, setOrderInfoMode] = useState(null);

  const setCustomerHandler = (customer) => {
    setCustomer(customer);
  };

  const setCustomerInfoModeHandler = (mode) => {
    setCustomerInfoMode(mode);
  };

  const setOrderHandler = (order) => {
    setOrderHandler(order);
  };

  const setOrderInfoModeHandler = (mode) => {
    setCustomerInfoMode(mode);
  };

  const contextValue = {
    customer: customer,
    customerInfoMode: customerInfoMode,
    order: order,
    orderInfoMode: orderInfoMode,

    setCustomerHandler: setCustomerHandler,
    setCustomerInfoModeHandler: setCustomerInfoModeHandler,
    setOrderHandler: setOrderHandler,
    setOrderInfoModeHandler: setOrderInfoModeHandler,
  };

  return <OrderContext.Provider>{props.children}</OrderContext.Provider>;
};

export default OrderContext;
